import { BaseGetYearGroupListService } from "../../../base/services/BaseGetYearGroupListService";
import { IGetListService } from "../../../abstractions/services/actions/IGetListService";
import { createCachedFactory } from "../../../utils/factoryUtils";
import { AnalisisLaboratorioResponse } from "../response/AnalisisLaboratorioResponse";
import { fx_createFertilizacionGrpcService } from "./FertilizacionGrpcService";

/** Servicio que retorna los análisis de una finca agrupados por año (años
 *  descendente, items descendente por fecha). Se apoya en el list service plano
 *  de la finca, así que hereda su sync delta e invalidaciones de cache. */
class FertilizacionGetYearGroupListByFincaIdService extends BaseGetYearGroupListService<AnalisisLaboratorioResponse> {
  /** @param _fincaId Finca cuyos análisis se agrupan por año. */
  constructor(private readonly _fincaId: string) {
    super();
  }

  /** Servicio de lista plana subyacente, scoped por finca. */
  protected get listService(): IGetListService<AnalisisLaboratorioResponse> {
    return fx_createFertilizacionGrpcService(this._fincaId);
  }

  /** Agrupa por el año de la fecha del análisis. */
  protected getFecha(item: AnalisisLaboratorioResponse): string {
    return item.fechaAnalisis;
  }
}

/** Factory cacheada: retorna una única instancia del servicio por fincaId. */
export const fx_createFertilizacionGetYearGroupListByFincaIdService =
  createCachedFactory(
    (fincaId) => new FertilizacionGetYearGroupListByFincaIdService(fincaId),
  );
